import * as css from './card.css';
import Header from '../header/header';
import {useTranslation} from 'react-i18next';

interface CardProps {
    mainTitle: any;
    subTitle: string;
    children: React.ReactNode;
    contactName?: string;
    contactPhone?: string;
}

const Card = ({mainTitle, subTitle, children, contactName, contactPhone}: CardProps) => {
    const {t}=useTranslation('suspendedConfirmation');
    return (
        <css.card>
            <Header 
                mainTitle={mainTitle} 
                subTitle={subTitle} 
            />
            {children}
            {(contactName || contactPhone) &&<css.footer>
                {t('producerDetails', {
                    contactName: contactName,
                    contactPhone: contactPhone
                })}
            </css.footer>}
        </css.card>
    );
};

export default Card;